import { render, staticRenderFns } from "./TabsProposed.vue?vue&type=template&id=21c96722&scoped=true&"
import script from "./TabsProposed.vue?vue&type=script&lang=js&"
export * from "./TabsProposed.vue?vue&type=script&lang=js&"
import style0 from "./TabsProposed.vue?vue&type=style&index=0&id=21c96722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c96722",
  null
  
)

export default component.exports